<template>
  <span>
    <router-link :to="{ name: 'contact', params: { contact_id: this.contact.id } }" class="text-light">
      {{contact.name}}
    </router-link>
  </span>
</template>

<script>
export default {
  props: {
    contact: {
      type: Object
    }
  }
}
</script>
